import { WebPaths } from '@griply/types';
import { getPathByString } from '@griply/utils';
import { desktopAppProtocol } from 'shared/constants';

export type OpenInAppTarget = {
  webPath: string;
  desktopUrl: string;
};

const stripTrailingSlash = (pathname: string): string =>
  pathname.length > 1 && pathname.endsWith('/')
    ? pathname.slice(0, -1)
    : pathname;

const isDeepLinkable = (pathname: string): boolean => {
  const matched = getPathByString(pathname);
  return !!matched && matched !== WebPaths.TaskCreate;
};

// linkPath is everything after `/open/`, query included; the desktop shell resolves the same page from `griply://<link>`.
export const getOpenInAppTarget = (linkPath: string): OpenInAppTarget => {
  const { pathname, search } = new URL(linkPath, 'https://open.invalid');
  const page = stripTrailingSlash(pathname);
  const webPath = isDeepLinkable(page) ? `${page}${search}` : WebPaths.Home;

  return {
    webPath,
    desktopUrl: `${desktopAppProtocol}://${webPath.slice(1)}`,
  };
};
